// src/services/pessoas/ClienteService.js
import { fetchData, patchData } from '../Api';

export const obterClientePorId = (clienteId) =>
  fetchData('/Cliente/GetClienteById', { clienteId });

export const obterClientePorTelefone = async (telefone) => {
  try {
    return await fetchData('/Cliente/GetClienteByTelefone', { telefone });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
};

export const corrigirEnderecoCliente = (clienteId, campos) =>
  patchData(`/Cliente/${clienteId}/Endereco`, campos);
